var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useReducer, } from "@wordpress/element";
import { getTaskDataRequest } from "../api/user-page-api";
import { SET_USER_PAGE_TASK_DATA, SET_USER_PAGE_TASK_LOADING, } from "../constants";
import { useErrorHandler } from "../hooks/useErrorHandler";
import { reducer } from "../reducers/user-page-task-reducer";
import { UserPageAppContext } from "./UserPageAppContextProvider";
const initialState = {
    task: null,
    taskStages: [],
    customFields: [],
    loading: true,
};
const UserPageTaskContext = createContext({
    state: initialState,
    userTaskDispatch: () => { },
    loadTask: () => { },
});
const UserPageTaskContextProvider = ({ children, taskHash, }) => {
    const [state, userTaskDispatch] = useReducer(reducer, initialState);
    const { state: { pageHash }, } = useContext(UserPageAppContext);
    const { handleError } = useErrorHandler();
    useEffect(() => {
        loadTask();
    }, []);
    const loadTask = () => __awaiter(void 0, void 0, void 0, function* () {
        if (taskHash) {
            try {
                userTaskDispatch({ type: SET_USER_PAGE_TASK_LOADING, payload: true });
                const response = yield getTaskDataRequest(pageHash, taskHash);
                userTaskDispatch({
                    type: SET_USER_PAGE_TASK_DATA,
                    payload: {
                        task: response.data.task,
                        stages: response.data.stages,
                        customFields: response.data.customFields,
                    },
                });
            }
            catch (error) {
                handleError(error);
            }
            finally {
                userTaskDispatch({ type: SET_USER_PAGE_TASK_LOADING, payload: false });
            }
        }
    });
    return (_jsx(UserPageTaskContext.Provider, { value: { state, userTaskDispatch, loadTask }, children: children }));
};
export { UserPageTaskContext, UserPageTaskContextProvider, };
